import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import logo from "../assets/logo.png";
import { useContext } from "react";
import { ClienteContext } from "../context/ClienteContext";

const Login = () => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const { atualizarCliente } = useContext(ClienteContext);


  const handleLogin = async () => {
    try {
      const response = await fetch("https://tsp-backend-yw2b.onrender.com/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usuario, senha }),
      });

      const data = await response.json();

      if (response.ok) {
        // ✅ Armazena tipo e cliente_id (caso exista)
        localStorage.setItem("tipo", data.tipo);
        localStorage.setItem("user_id", data.id);
        localStorage.setItem("token", data.access_token); 
        localStorage.setItem("nome", data.nome);


        if (data.cliente_id) {
          localStorage.setItem("cliente_id", data.cliente_id);
          atualizarCliente(data.cliente_id); // ✅ força o carregamento imediato do cliente no contexto
        }
        

        // ✅ Redireciona conforme o tipo
        if (data.tipo === "master") {
          navigate("/dashhome");
        } else {
          navigate("/dashboard");
        }

        alert("Login realizado com sucesso!");
      } else {
        alert(data.erro || "Usuário ou senha inválidos.");
      }
    } catch (error) {
      console.error("Erro ao fazer login:", error);
      alert("Erro de conexão com o servidor.");
    }
  };

  return (
    <div className="login-container">
      <img src={logo} alt="Logo" className="login-logo" />
      <div className="login-form">
        <input
          type="text"
          placeholder="Usuário"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
        />
        <input
          type="password"
          placeholder="Senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
        <div className="login-link" onClick={handleLogin}>
          entrar
        </div>
      </div>
      <p className="login-footer">© 2025 Copyrights Mazzali R., All Rights Reserved</p>
    </div>
  );
};

export default Login;
